
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { ReactNode } from "react";

const linkifyDescription = (text: string): ReactNode[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);
  return parts.map((part, i) =>
    urlRegex.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#ffd700] underline hover:text-[#ffd700]/80 break-all"
      >
        {part}
      </a>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};

interface PropertyDetailTabsProps {
  propertyType: string | null;
  foundationType: string | null;
  lotSize: string | null;
  parkingType: string | null;
  roofAge: string | null;
  windowType: string | null;
  furnaceAge: string | null;
  waterHeaterAge: string | null;
  architectureStyle: string | null;
  description: string | null;
  units?: number | null;
}

export const PropertyDetailTabs = ({
  propertyType,
  foundationType,
  lotSize,
  parkingType,
  roofAge,
  windowType,
  furnaceAge,
  waterHeaterAge,
  architectureStyle,
  description,
  units
}: PropertyDetailTabsProps) => {

  return (
    <Tabs defaultValue="details" className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="details">Additional Details</TabsTrigger>
        <TabsTrigger value="overview">Overview</TabsTrigger>
      </TabsList>
      <TabsContent value="details" className="mt-4">
        <Card>
          <CardContent className="p-4">
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              <div>
                <p className="text-sm text-muted-foreground">Property Type</p>
                <p className="font-medium">{propertyType || 'N/A'}</p>
              </div>
              {propertyType === 'multi-unit' && units != null && (
                <div>
                  <p className="text-sm text-muted-foreground">Number of Units</p>
                  <p className="font-medium">{units}</p>
                </div>
              )}
              <div>

                <p className="text-sm text-muted-foreground">Foundation</p>
                <p className="font-medium">{foundationType || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Lot Size</p>
                <p className="font-medium">{lotSize || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Parking</p>
                <p className="font-medium">{parkingType || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Roof Age</p>
                <p className="font-medium">{roofAge || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Window Type</p>
                <p className="font-medium">{windowType || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Furnace Age</p>
                <p className="font-medium">{furnaceAge || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Water Heater Age</p>
                <p className="font-medium">{waterHeaterAge || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Architecture Style</p>
                <p className="font-medium">{architectureStyle || 'N/A'}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
      <TabsContent value="overview" className="mt-4">
        <Card>
          <CardContent className="p-4 space-y-4">
            <h3 className="font-semibold">Property Description</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {description ? linkifyDescription(description) : "No description provided for this property."}
            </p>
          </CardContent>
        </Card>
      </TabsContent>
    </Tabs>
  );
};
